import React, { useState } from 'react';
import { Button, Input, Form as AntForm, Alert, Select } from 'antd';
import { Formik } from 'formik';
import openErrorNotification from '../../Utils/openErrorNotification';
import style from './Forms.module.css';
import { useDispatch } from 'react-redux';
import api from '../../Api/api';
import {
  REQUEST_GET_ALL_USERS_FOR_ADMIN,
  REQUEST_GET_USER_DATA_FOR_ADMIN,
} from '../../Redux/constants/constants';
import {
  validateEmail,
  validateFloat,
  validateInt,
} from '../../Utils/validateWithRegex';

const { Option } = Select;

const NewUser = () => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState('');

  return (
    <Formik
      initialValues={{
        name: '',
        role: 'user',
        email: '',
        hourlyWage: '',
        leaveAmount: '',
        status: 'active',
      }}
      validateOnChange={false}
      validate={(values) => {
        const errors = {};
        if (values.name === '') {
          errors.name = 'wymagane';
        }
        if (values.email === '') {
          errors.email = 'wymagane';
        }
        if (!validateEmail(values.email)) {
          errors.email = 'błędny adres email';
        }
        if (values.hourlyWage === '') {
          errors.hourlyWage = 'wymagane';
        }
        // check for float
        if (!validateFloat(values.hourlyWage)) {
          errors.hourlyWage = 'błędna wartość';
        }
        if (values.leaveAmount === '') {
          errors.leaveAmount = 'wymagane';
        }
        if (!validateInt(values.leaveAmount)) {
          errors.leaveAmount = 'błędna wartość';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        api
          .postUserData(values)
          .then((res) => {
            setSubmitting(false);
            setStatus('saved');
            dispatch({
              type: REQUEST_GET_USER_DATA_FOR_ADMIN,
              payload: res.data.id,
            });
            dispatch({ type: REQUEST_GET_ALL_USERS_FOR_ADMIN });
          })
          .catch((e) => {
            setSubmitting(false);
            setStatus('error');
            openErrorNotification(e);
          });
      }}
    >
      {({ isSubmitting, values, errors, handleSubmit, setFieldValue }) => (
        <AntForm
          className={style.wrapper}
          labelCol={{ span: 8 }}
          layout="horizontal"
          wrapperCol={{ span: 16 }}
        >
          <AntForm.Item
            required={true}
            validateStatus={errors.name && 'error'}
            help={errors.name}
            label="Imię i nazwisko"
          >
            <Input
              placeholder={values.name}
              onChange={(e) => {
                return setFieldValue('name', e.target.value);
              }}
            />
          </AntForm.Item>
          <AntForm.Item
            validateStatus={errors.role && 'error'}
            help={errors.role}
            label="Rola"
          >
            <Select
              type="role"
              name="role"
              value={values.role}
              defaultValue="user"
              onChange={(value) => setFieldValue('role', value)}
            >
              <Option value="user">user</Option>
              <Option value="admin">admin</Option>
            </Select>
          </AntForm.Item>
          <AntForm.Item
            required={true}
            validateStatus={errors.email && 'error'}
            help={errors.email}
            label="Email"
          >
            <Input
              placeholder={values.email}
              onChange={(e) => {
                return setFieldValue('email', e.target.value);
              }}
            />
          </AntForm.Item>
          <AntForm.Item
            required={true}
            validateStatus={errors.hourlyWage && 'error'}
            help={errors.hourlyWage}
            label="Stawka godzinowa"
          >
            <Input
              placeholder={values.hourlyWage}
              suffix="zł"
              onChange={(e) => {
                return setFieldValue('hourlyWage', e.target.value);
              }}
            />
          </AntForm.Item>
          <AntForm.Item
            required={true}
            validateStatus={errors.leaveAmount && 'error'}
            help={errors.leaveAmount}
            label="Ilość urlopu"
          >
            <Input
              placeholder={values.leaveAmount}
              suffix="dni"
              onChange={(e) => {
                return setFieldValue('leaveAmount', e.target.value);
              }}
            />
          </AntForm.Item>

          <Button type="submit" disabled={isSubmitting} onClick={handleSubmit}>
            Wyślij
          </Button>
          {status === 'saved' && (
            <Alert message="Pracownik zapisany" type="success" showIcon />
          )}
          {status === 'error' && (
            <Alert message="Błąd zapisu" type="error" showIcon />
          )}
        </AntForm>
      )}
    </Formik>
  );
};

export default NewUser;
